export function getSliceData ({ data, currentPage, pageSize }) {
  const begin = (currentPage - 1) * pageSize
  const end = begin + pageSize 
  return data.slice(begin, end)
}
